import { createI18n } from 'vue-i18n';
import lang_de from '@/locale/langs/de';
import date_de from '@/locale/dates/de';
var i18n = createI18n({
    // The default locale
    locale: "de",
    // The fallback locale
    fallbackLocale: "de",
    // Globally inject i18n
    globalInjection: true,
    // The localized messages
    messages: { "de": lang_de },
    // Set the datetime formats
    datetimeFormats: { "de": date_de },
});
export default i18n;
